import { AppContent } from 'content/AppContent';

const unableToVerify: AppContent['unableToVerify'] = {
  unableToVerifyContent: [
    {
      serviceName: 'Online for Business',
      heading: 'We’ve not been able to verify you',
      content1: 'You’ll need to start your request to register again.',
      tryAgainButton: 'Try again',
      tryAgainLink: '/',
    },
  ],
};

export default unableToVerify;
